(function() {
  if (window.__productCardAuthRedirectInitialized) return;
  window.__productCardAuthRedirectInitialized = true;

  function hasExistingAccountSignal() {
    try {
      var cookies = document.cookie || '';
      var local = window.localStorage || {};
      if (cookies.indexOf('has_account=1') !== -1 || cookies.indexOf('has_account=true') !== -1) {
        return true;
      }
      if (local.getItem('has_account') === '1' || local.getItem('has_account') === 'true') {
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest && event.target.closest('.product-card__login-link[data-auth-redirect]');
    if (!link) return;
    if (!hasExistingAccountSignal()) return;
    event.preventDefault();
    window.location.href = window.b2bLoginUrl || '/customer_authentication/login?return_to=%2F';
  });
})();
